import { render, staticRenderFns } from "./PersonBillReceiveForm.vue?vue&type=template&id=742de140"
import script from "./PersonBillReceiveForm.vue?vue&type=script&lang=js"
export * from "./PersonBillReceiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports